import AppConfiguration, { ENV_NAME } from '../config/config';
import { getLeadHeaders, getLeadPayload, getLoginToken, getParams, getRequest, getRequestForExistingLead, getURLForFetchingExisitingLead } from './request.helper';
import axios from 'common/interceptor/app.interceptor';
import { IGetLead, IGetLeadRequest, ILeadRequest } from './lead.interface';
import { validateTokenForOrder } from 'common/services/http.service';
import { saveLead } from './lead.util';
import { handleLeadResponse } from './response.handler';

const isDevEnv = () => AppConfiguration.env === ENV_NAME.DEV;
const METHOD = {
  POST: 'POST',
  GET: 'GET',
  PUT: 'PUT',
  DELETE: 'DELETE'
};

export const updateLead = (rawRequest?: ILeadRequest) => {
  const request = getRequest(rawRequest?.headers, rawRequest?.payload, rawRequest?.params);
  return axios({
    method: METHOD.POST,
    url: `${AppConfiguration.apiBaseUrl}lead/update`,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    },
    data: request.payload,
    headers: request.headers,
    params: request.params
  });
};

export const createLeadForDev = (rawRequest?: ILeadRequest) => {
  const request = getRequest(rawRequest?.headers, rawRequest?.payload, rawRequest?.params);
  const isSingleSiteUpgrade = rawRequest?.payload?.circuitId;
  const URI = isSingleSiteUpgrade ? `${AppConfiguration.pnqapiBaseUrl}aehLead/createLead` : `${AppConfiguration.apiBaseUrl}lead/create`;
  const getHeaders = () => {
    if (isSingleSiteUpgrade) {
      return {
        accessToken: getLoginToken()
      };
    }

    return request.headers;
  };

  return axios({
    method: METHOD.POST,
    url: URI,
    config: {
      ignoreError: false,
      dedicatedJourney: true
    },
    data: request.payload,
    headers: getHeaders(),
    params: request.params
  });
};

export const fetchAOIAccountsAsync = (params: any) => {
  const URI = `${AppConfiguration.apiBaseUrl}customer/details`;

  return axios({
    method: METHOD.GET,
    url: URI,
    params,
    headers: {
      'Content-Type': 'application/json'
    },
    config: {
      aehToken: getLoginToken(),
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};

const createLeadforAuth = (rawRequest?: ILeadRequest) => {
  const request = getRequest(rawRequest?.headers, rawRequest?.payload, rawRequest?.params);
  const isSingleSiteUpgrade = rawRequest?.payload?.circuitId;
  const URI = isSingleSiteUpgrade ? `${AppConfiguration.pnqapiBaseUrl}aehLead/createLead` : `${AppConfiguration.apiCallAEHUrl}lead/create`;
  const getHeaders = () => {
    if (isSingleSiteUpgrade) {
      return {
        accessToken: getLoginToken()
      };
    }

    return request.headers;
  };

  return axios({
    method: METHOD.POST,
    url: URI,
    config: {
      aehToken: getLoginToken(),
      ignoreError: false,
      dedicatedJourney: true
    },
    data: request.payload,
    headers: getHeaders(),
    params: request.params
  });
};

export const createLead = (rawRequest?: ILeadRequest) => {
  if (isDevEnv()) {
    return createLeadForDev(rawRequest);
  }
  return createLeadforAuth(rawRequest);
};

export const fetchLeadToken = (rawRequest?: IGetLeadRequest) => {
  const request = getRequestForExistingLead(rawRequest);
  const url = request.url ?? getURLForFetchingExisitingLead(false);
  return axios({
    method: METHOD.POST,
    data: request.payload,
    url,
    headers: {
      'Content-Type': 'application/json'
    },
    config: {
      ignoreError: false,
      dedicatedJourney: true
    }
  });
};

const validateAndSaveConfirmOrderParams = (type: string, orderId: string, authToken: string) => {
  // setLoading(true);
  validateTokenForOrder(authToken, type, orderId).then(
    (rawResponse: any) => {
      handleLeadResponse(rawResponse);
    },
    (err) => {
      console.log(err);
    }
  );
};

export {};
